<template>
  <div>
    <router-link to="/act2/main">
      <div class="main" style="background-image:url(static/img/act/2/banner/bg.jpg)" >
        <img  class="act-2-banner-title" src="static/img/act/2/banner/title.png" />
        <img  class="act-2-banner-bh ma-left-right" src="static/img/act/2/banner/bh.png" />
        <img id="act2BannerMa" class="act-2-banner-ma fen-up-down" src="static/img/act/2/banner/ma.png?v=2" />
        <img  class="act-2-banner-qh ma-right-left" src="static/img/act/2/banner/qh.png" />
        <img  class="act-2-banner-btn" src="static/img/act/2/btn-show.png" />
      </div>
    </router-link>    
  </div>
</template>
 

<script>
//动画
import Velocity from "velocity-animate";

export default {
  name: "Act4Banner",
  components: {
  },
  data() {
    return {
    };
  },
  mounted() {},
  created() {
    this.setDocumentV2(
      "苗族系列坡会群",
      "",
      "https://z.lzgd.com.cn/inliuzhou/2018/LiuzhouTourism/static/img/act/4/share.jpg?v=2"
    );
    _czc.push(['_trackEvent', '苗族系列坡会群', '点击', 'Banner页面','0','2']);
  },
  methods: {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main {
  position: absolute;
  width: 100%;
  height: 100%;
  background-position: center top !important;
  background-size: 103% auto !important;
  background-repeat:no-repeat;
  overflow: hidden;
} 

.act-2-banner-btn{
  position: absolute;
  top: 62%; 
  width: 12%;
  height: auto;
  right: 10px;
}

.act-2-banner-title{
  position: absolute;
  top: 3%;
  left: 7%;
  width: 86%;
}


.act-2-banner-bh{
  position: absolute;
  bottom: 7%;
  left: -2.5%;
  width: 105%;
}
.act-2-banner-ma{
  position: absolute;
  bottom: -2%;
  left: -15%;
  width: 120%;
}
.act-2-banner-qh{
  position: absolute;
  bottom: 7%;
  left: -2.5%;
  width: 105%;
}


@media screen and (max-width: 320px) {
  .act-2-banner-title{
    position: absolute;
    top: 3%;
    left: 7%;
    width: 86%;
  }
}
@media screen and (max-width: 320px) and (max-height: 480px) {
  .act-2-banner-title{
    z-index: 2;
  }
}
@media screen and (max-width: 375px) and (max-height: 812px) {
 .act-2-banner-ma{
  
  }
}


/*  粉   */

.ma {
  pointer-events: auto;
  -webkit-user-select: auto;
}

@-webkit-keyframes ma-frames-left-right {
  0% {
    -webkit-transform: translateX(-4px);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(-4px));
    -moz-transform-origin: top center;
    transform: translateX(-4px);
    transform-origin: top center;
  }
  100% {
    -webkit-transform: translateX(4px);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(4px);
    -moz-transform-origin: top center;
    transform: translateX(4px);
    transform-origin: top center;
  }
}

@keyframes ma-frames-left-right {
  0% {
    -webkit-transform: translateX(-4px);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(-4px));
    -moz-transform-origin: top center;
    transform: translateX(-4px);
    transform-origin: top center;
  }
  100% {
    -webkit-transform: translateX(4px);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(4px);
    -moz-transform-origin: top center;
    transform: translateX(4px);
    transform-origin: top center;
  }
}

.ma-left-right {
  -webkit-animation: ma-frames-left-right 2000ms ease-in-out alternate infinite;
  -moz-animation: ma-frames-left-right 2000ms ease-in-out alternate infinite;
  animation: ma-frames-left-right 2000ms ease-in-out alternate infinite;
  animation-delay: 360ms;
  -webkit-animation-delay: 360ms;
}



@-webkit-keyframes ma-frames-right-left {
  0% {
    -webkit-transform: translateX(4px);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(4px));
    -moz-transform-origin: top center;
    transform: translateX(4px);
    transform-origin: top center;
  }
  100% {
    -webkit-transform: translateX(-4px);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(-4px);
    -moz-transform-origin: top center;
    transform: translateX(-4px);
    transform-origin: top center;
  }
}

@keyframes ma-frames-right-left {
  0% {
    -webkit-transform: translateX(4px);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(4px));
    -moz-transform-origin: top center;
    transform: translateX(4px);
    transform-origin: top center;
  }
  100% {
    -webkit-transform: translateX(-4px);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(-4px);
    -moz-transform-origin: top center;
    transform: translateX(-4px);
    transform-origin: top center;
  }
}

.ma-right-left {
  -webkit-animation: ma-frames-right-left 2000ms ease-in-out alternate infinite;
  -moz-animation: ma-frames-right-left 2000ms ease-in-out alternate infinite;
  animation: ma-frames-right-left 2000ms ease-in-out alternate infinite;
  animation-delay: 360ms;
  -webkit-animation-delay: 360ms;
}

</style>


// WEBPACK FOOTER //
// src/components/act/2/Banner.vue